export default function FacebookLogo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.4939 3.55981 14.3899 6.90625 14.915V10.0234H5.12891V8H6.90625V6.45781C6.90625 4.70344 7.95133 3.73437 9.55028 3.73437C10.3161 3.73437 11.1172 3.87109 11.1172 3.87109V5.59375H10.2345C9.36495 5.59375 9.09375 6.13335 9.09375 6.68695V8H11.0352L10.7248 10.0234H9.09375V14.915C12.4402 14.3899 15 11.4939 15 8Z"
        fill="#1877F2"
        className="path-fill"
      />
      <path
        d="M10.7248 10.0234L11.0352 8H9.09375V6.68695C9.09375 6.1333 9.36495 5.59375 10.2345 5.59375H11.1172V3.87109C11.1172 3.87109 10.3161 3.73438 9.55023 3.73438C7.95133 3.73438 6.90625 4.70344 6.90625 6.45781V8H5.12891V10.0234H6.90625V14.915C7.26807 14.9717 7.63376 15.0001 8 15C8.36624 15.0001 8.73193 14.9717 9.09375 14.915V10.0234H10.7248Z"
        fill="white"
      />
    </svg>
  );
}
